import React from "react";
import DashboardDataTag from "./DashboardDataTag";
import DataTagLayout from "./DataTagLayout";
import DataEstate from "./DataEstate/DataEstate";
import DataTagReports from "./DataTagReports";

function DataGuardHomePage() {
   const tabs = [
    {
      name: "Enterprise Dashboard",
      component: <DashboardDataTag />
    },
    {
      name: "Data Estate",
      component: <DataEstate />
    },
    {
      name: "Reports",
      component: <DataTagReports />
    },
  ];
  return <div><DataTagLayout tabs={tabs}/></div>;
}

export default DataGuardHomePage;
